(() => {
  const offer = document.querySelector("[data-cb-site-offer]");
  const panel = document.querySelector("[data-cb-support-panel]");
  const backdrop = document.querySelector("[data-cb-support-backdrop]");
  const closeButton = document.querySelector("[data-cb-support-close]");
  let lastSupportTrigger = null;

  if (offer) {
    document.body.classList.add("cb-site-tools-active");
    const syncOfferOffset = () => {
      document.documentElement.style.setProperty(
        "--cb-site-offer-height",
        `${Math.ceil(offer.getBoundingClientRect().height)}px`
      );
    };
    syncOfferOffset();
    if ("ResizeObserver" in window) {
      new ResizeObserver(syncOfferOffset).observe(offer);
    } else {
      window.addEventListener("resize", syncOfferOffset, { passive: true });
    }
  }

  if (document.querySelector(".cn-sticky, .cb-sticky, [data-cb-sticky-cart]")) {
    document.body.classList.add("cbx-has-sticky-cart");
  }

  const track = (name, detail = {}) => {
    const payload = {
      event: name,
      page_path: window.location.pathname,
      ...detail
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent(`conebarn:${name}`, { detail: payload }));

    if (window.Shopify?.analytics?.publish) {
      try {
        window.Shopify.analytics.publish(name, payload);
      } catch (error) {
        // Other analytics sinks still receive the event.
      }
    }
  };

  const setCouponState = (applied) => {
    if (!offer) return;
    const copy = offer.querySelector("[data-cb-offer-copy]");
    const button = offer.querySelector("[data-cb-apply-coupon]");
    offer.classList.toggle("is-applied", applied);

    if (copy) {
      copy.textContent = applied
        ? "WELCOME1 selected. Best eligible offer shows at checkout."
        : "Welcome offer: $1 off. Code WELCOME1.";
    }

    if (button) {
      button.textContent = applied ? "Reapply" : "Save coupon";
      button.disabled = false;
    }
  };

  const applyCoupon = () => {
    if (!offer) return;
    const code = offer.dataset.couponCode;
    if (!code) return;

    try {
      window.sessionStorage.setItem("cb_coupon_welcome1_session_v1", "true");
    } catch (error) {
      // The Shopify discount route remains functional without session storage.
    }

    track("coupon_apply", {
      coupon_code: code,
      coupon_offer: "one_dollar_order_nonstacking"
    });
    const returnPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    window.location.assign(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(returnPath)}`);
  };

  const openSupport = (trigger) => {
    if (!panel || !backdrop) return;
    lastSupportTrigger = trigger || document.activeElement;
    panel.hidden = false;
    backdrop.hidden = false;
    requestAnimationFrame(() => {
      panel.classList.add("is-open");
      backdrop.classList.add("is-open");
      document.body.classList.add("cb-support-lock");
      closeButton?.focus();
    });
    track("support_open");
  };

  const closeSupport = () => {
    if (!panel || !backdrop) return;
    panel.classList.remove("is-open");
    backdrop.classList.remove("is-open");
    document.body.classList.remove("cb-support-lock");
    window.setTimeout(() => {
      panel.hidden = true;
      backdrop.hidden = true;
    }, 220);
    lastSupportTrigger?.focus?.();
  };

  document.addEventListener("click", (event) => {
    const clickedElement = event.target instanceof Element ? event.target : null;
    const actionElement = clickedElement?.closest(
      "a,button,input,select,summary,[role='button'],[data-cb-track-label]"
    );
    const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    const destination = actionElement?.tagName === "A"
      ? actionElement.getAttribute("href")
      : null;

    track("site_click", {
      click_x_pct: viewportWidth ? Math.round((event.clientX / viewportWidth) * 1000) / 10 : null,
      click_y_pct: viewportHeight ? Math.round((event.clientY / viewportHeight) * 1000) / 10 : null,
      element_tag: (actionElement || clickedElement)?.tagName?.toLowerCase() || "unknown",
      element_id: (actionElement || clickedElement)?.id || null,
      element_role: actionElement?.getAttribute("role") || null,
      element_label:
        actionElement?.dataset.cbTrackLabel ||
        actionElement?.getAttribute("aria-label") ||
        null,
      destination: destination?.startsWith("/") ? destination.split("?")[0] : null,
      is_interactive: Boolean(actionElement),
      viewport_width: viewportWidth,
      viewport_height: viewportHeight
    });

    const couponTrigger = event.target.closest("[data-cb-apply-coupon]");
    if (couponTrigger) {
      event.preventDefault();
      applyCoupon();
      return;
    }

    const supportTrigger = event.target.closest("[data-cb-support-trigger]");
    if (supportTrigger) {
      event.preventDefault();
      openSupport(supportTrigger);
      return;
    }

    const supportLink = event.target.closest("[data-cb-support-link]");
    if (supportLink) {
      track("support_contact_click", { destination: supportLink.dataset.cbSupportLink });
    }
  });

  closeButton?.addEventListener("click", closeSupport);
  backdrop?.addEventListener("click", closeSupport);
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && panel?.classList.contains("is-open")) {
      closeSupport();
    }
  });

  let couponApplied = false;
  try {
    couponApplied = window.sessionStorage.getItem("cb_coupon_welcome1_session_v1") === "true";
  } catch (error) {
    couponApplied = false;
  }
  setCouponState(couponApplied);

  window.ConeBarnSiteTools = {
    applyCoupon,
    openSupport,
    track
  };
})();

/* Global language marker and direct checkout action — 2026-09-20 */
(() => {
  const locale = (document.documentElement.lang || "en").toLowerCase();
  const languageBlock = document.querySelector("[data-cb-global-language]");

  if (languageBlock) {
    const otherLanguageSelector = Array.from(document.querySelectorAll('select[name="locale_code"]'))
      .find((select) => !languageBlock.contains(select));
    if (!otherLanguageSelector) {
      const categoryNavigation = document.querySelector(".cb-restore-directory__links")
        || document.querySelector(".cn-nav__links")
        || document.querySelector(".header__inline-menu");
      if (categoryNavigation) {
        categoryNavigation.insertAdjacentElement("afterend", languageBlock);
        languageBlock.classList.add("is-nav-positioned");
      }
      languageBlock.hidden = false;
      languageBlock.classList.add("is-visible");
    }
  }

  const currencyBlock = document.querySelector("[data-cb-reference-currency]");
  const currencySelect = document.querySelector("[data-cb-reference-currency-select]");

  if (currencyBlock && currencySelect) {
    const anchor = document.querySelector(".cb-product-nav")
      || document.querySelector(".cb-restore-directory")
      || document.querySelector(".cn-nav")
      || document.querySelector("header");
    if (anchor) anchor.insertAdjacentElement("afterend", currencyBlock);
    else document.querySelector("main")?.insertAdjacentElement("beforebegin", currencyBlock);
    currencyBlock.hidden = false;
    currencyBlock.classList.add("is-visible");

    const syncCurrencyStickyOffset = () => {
      const stickyOffer = document.querySelector("[data-cb-site-offer]");
      const offerHeight = stickyOffer ? stickyOffer.getBoundingClientRect().height : 0;
      let anchorHeight = 0;
      if (anchor) {
        const anchorPosition = window.getComputedStyle(anchor).position;
        if (anchorPosition === "sticky" || anchorPosition === "fixed") {
          anchorHeight = anchor.getBoundingClientRect().height;
        }
      }
      currencyBlock.style.setProperty(
        "--cb-reference-sticky-top",
        `${Math.ceil(offerHeight + anchorHeight)}px`
      );
    };
    syncCurrencyStickyOffset();
    window.addEventListener("resize", syncCurrencyStickyOffset, { passive: true });
    if ("ResizeObserver" in window) {
      const stickyOffsetObserver = new ResizeObserver(syncCurrencyStickyOffset);
      const stickyOffer = document.querySelector("[data-cb-site-offer]");
      if (stickyOffer) stickyOffsetObserver.observe(stickyOffer);
      if (anchor) stickyOffsetObserver.observe(anchor);
    }

    // USD cross-rates derived from the ECB 18 Sep 2026 euro reference rates.
    // These values are deliberately display-only; Shopify checkout remains in USD.
    const referenceRates = {
      USD: 1,
      BRL: 5.135864,
      MXN: 17.177574,
      TRY: 48.785079,
      EUR: 0.872600,
      CAD: 1.401047,
      INR: 95.877400,
      GBP: 0.749389,
      AUD: 1.404450
    };
    const countryCurrency = {
      BR: "BRL", MX: "MXN", TR: "TRY", CA: "CAD", IN: "INR",
      GB: "GBP", AU: "AUD", AT: "EUR", BE: "EUR", DE: "EUR",
      ES: "EUR", FI: "EUR", FR: "EUR", IE: "EUR", IT: "EUR",
      NL: "EUR", PT: "EUR"
    };
    const browserLanguage = (navigator.language || "").toLowerCase();
    const languageFallback = browserLanguage.startsWith("pt-br") ? "BRL"
      : browserLanguage.startsWith("es-mx") ? "MXN"
      : browserLanguage.startsWith("tr") ? "TRY"
      : browserLanguage.startsWith("en-ca") ? "CAD"
      : browserLanguage.startsWith("en-gb") ? "GBP"
      : browserLanguage.startsWith("en-au") ? "AUD"
      : browserLanguage.startsWith("hi") ? "INR"
      : "USD";
    let storedCurrency = "";
    try { storedCurrency = window.localStorage.getItem("cb_reference_currency_v1") || ""; } catch (error) {}
    const detectedCurrency = countryCurrency[window.Shopify?.country] || languageFallback;
    let activeCurrency = referenceRates[storedCurrency] ? storedCurrency : detectedCurrency;
    currencySelect.value = activeCurrency;

    const priceSelectors = [
      ".cbap__price",
      ".cb-price",
      ".cb-price-was",
      ".price-item--regular",
      ".price-item--sale",
      ".cn-card-buy__price",
      ".product__info-container .price-item",
      ".cart-item__price-wrapper .price",
      ".cart-item__totals .price",
      ".totals__total-value"
    ].join(",");

    const parseUsd = (text) => {
      const match = String(text || "").replace(/,/g, "").match(/\$\s*(\d+(?:\.\d{1,2})?)/);
      return match ? Number.parseFloat(match[1]) : null;
    };

    const formatReference = (amount, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || "en", {
          style: "currency",
          currency,
          maximumFractionDigits: currency === "INR" ? 0 : undefined
        }).format(amount * referenceRates[currency]);
      } catch (error) {
        return `${currency} ${(amount * referenceRates[currency]).toFixed(2)}`;
      }
    };

    const refreshReferencePrices = () => {
      document.querySelectorAll("[data-cb-reference-price]").forEach((node) => node.remove());
      if (activeCurrency === "USD") return;
      document.querySelectorAll(priceSelectors).forEach((priceNode) => {
        if (priceNode.closest("select, option") || priceNode.hidden || priceNode.offsetParent === null) return;
        const usdAmount = parseUsd(priceNode.textContent);
        if (!Number.isFinite(usdAmount)) return;
        const converted = document.createElement("small");
        converted.className = "cb-reference-price";
        converted.dataset.cbReferencePrice = activeCurrency;
        converted.textContent = `≈ ${formatReference(usdAmount, activeCurrency)}`;
        priceNode.insertAdjacentElement("afterend", converted);
      });
    };

    let refreshTimer = 0;
    const scheduleRefresh = () => {
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(refreshReferencePrices, 80);
    };

    currencySelect.addEventListener("change", () => {
      activeCurrency = referenceRates[currencySelect.value] ? currencySelect.value : "USD";
      try { window.localStorage.setItem("cb_reference_currency_v1", activeCurrency); } catch (error) {}
      window.ConeBarnSiteTools?.track?.("reference_currency_change", {
        reference_currency: activeCurrency,
        checkout_currency: "USD"
      });
      refreshReferencePrices();
    });

    new MutationObserver((mutations) => {
      const onlyReferenceChanges = mutations.every((mutation) => {
        const changedNodes = [...mutation.addedNodes, ...mutation.removedNodes];
        return changedNodes.length > 0 && changedNodes.every((node) =>
          node.nodeType === 1 && node.matches?.("[data-cb-reference-price]")
        );
      });
      if (!onlyReferenceChanges) scheduleRefresh();
    }).observe(document.querySelector("main") || document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
    refreshReferencePrices();
  }

  const paymentBadge = document.querySelector("[data-cb-payment-badge]");
  if (paymentBadge) {
    const isProductPage = window.location.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i);
    const isCartPage = window.location.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i);
    const productForm = document.querySelector('.cbap__info form[action*="/cart/add"]')
      || document.querySelector('.product-form form[action*="/cart/add"]');
    const cartFooter = document.querySelector(".cart__footer");
    if (isProductPage && productForm) {
      productForm.insertAdjacentElement("afterend", paymentBadge);
    } else if (isCartPage && cartFooter) {
      cartFooter.insertAdjacentElement("afterbegin", paymentBadge);
    } else {
      currencyBlock?.querySelector(".cb-reference-currency__inner")?.append(paymentBadge);
      paymentBadge.classList.add("cb-payment-badge--global");
    }
    paymentBadge.hidden = false;
    paymentBadge.classList.add("is-visible");

    if (currencyBlock && !currencyBlock.contains(paymentBadge)) {
      const stickyPaymentBadge = paymentBadge.cloneNode(true);
      stickyPaymentBadge.removeAttribute("data-cb-payment-badge");
      stickyPaymentBadge.hidden = false;
      stickyPaymentBadge.classList.add("is-visible", "cb-payment-badge--global");
      stickyPaymentBadge.setAttribute("aria-label", paymentBadge.textContent.trim());
      currencyBlock.querySelector(".cb-reference-currency__inner")?.append(stickyPaymentBadge);
    }
  }

  if (!window.location.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i)) return;

  const labels = locale.startsWith("pt")
    ? { buy: "Comprar agora", opening: "Abrindo checkout…", retry: "Tentar novamente" }
    : locale.startsWith("es")
      ? { buy: "Comprar ahora", opening: "Abriendo pago…", retry: "Intentar de nuevo" }
      : locale.startsWith("fr")
        ? { buy: "Acheter maintenant", opening: "Ouverture du paiement…", retry: "Réessayer" }
        : locale.startsWith("de")
          ? { buy: "Jetzt kaufen", opening: "Checkout wird geöffnet…", retry: "Erneut versuchen" }
          : locale.startsWith("it")
            ? { buy: "Acquista ora", opening: "Apertura del pagamento…", retry: "Riprova" }
            : { buy: "Buy now", opening: "Opening checkout…", retry: "Try again" };

  const root = window.Shopify?.routes?.root || "/";

  async function directCheckout(form, button, selected = {}) {
    const variantField = form.querySelector('[name="id"]');
    const quantityField = form.querySelector('[name="quantity"]');
    const variantId = selected.variantId || variantField?.value;
    const quantity = Math.max(1, Number.parseInt(selected.quantity || quantityField?.value || "1", 10) || 1);
    if (!variantId) return;

    button.disabled = true;
    button.textContent = labels.opening;
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
      });
      if (!response.ok) throw new Error("cart_add_failed");
      window.ConeBarnSiteTools?.track?.("direct_checkout_click", {
        product_path: window.location.pathname,
        variant_id: String(variantId),
        quantity
      });
      window.location.assign(`${root}checkout`);
    } catch (error) {
      button.disabled = false;
      button.textContent = labels.retry;
    }
  }

  function mountDirectBuy() {
    const existingDirectBuy = Array.from(document.querySelectorAll('button, input[type="submit"], a'))
      .some((element) => {
        if (element.classList.contains("cb-direct-buy-button")) return true;
        if (element.matches(".shopify-payment-button__button")) return true;
        const label = (element.textContent || element.value || element.getAttribute("aria-label") || "").trim();
        return /^(buy now|comprar agora|comprar ahora|acheter maintenant|jetzt kaufen|acquista ora)$/i.test(label);
      });
    if (existingDirectBuy) return;

    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      if (form.dataset.cbDirectBuyMounted === "true") return;
      const purchaseButtons = Array.from(form.querySelectorAll(
        'button[type="submit"], input[type="submit"], button[name="add"], .cb-atc-btn, .cb-pdp-card__btn'
      ));
      if (!purchaseButtons.length) return;
      form.dataset.cbDirectBuyMounted = "true";
      purchaseButtons.forEach((purchaseButton) => {
        const inlineAction = purchaseButton.getAttribute("onclick") || "";
        const cardPayload = inlineAction.match(/cbPdpCardBuy\(\s*(\d+)\s*,\s*(\d+)/);
        const selected = cardPayload
          ? { variantId: cardPayload[1], quantity: cardPayload[2] }
          : {};
        const button = document.createElement("button");
        button.type = "button";
        button.className = "cb-direct-buy-button";
        if (purchaseButton.matches(".cb-pdp-card__btn")) {
          button.classList.add("cb-direct-buy-button--compact");
        }
        button.textContent = labels.buy;
        button.setAttribute("aria-label", labels.buy);
        button.addEventListener("click", () => directCheckout(form, button, selected));
        purchaseButton.insertAdjacentElement("afterend", button);
      });
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", mountDirectBuy);
  else mountDirectBuy();
  document.addEventListener("shopify:section:load", mountDirectBuy);
})();

/* ConeBarn two-step WhatsApp help intake — 2026-09-15 */
(() => {
  const SUPPORT_NUMBER = document.querySelector("[data-cb-support-panel]")?.dataset.whatsappNumber || "";
  const ATTRIBUTION_KEY = "cb_help_attribution_v3";
  const SESSION_KEY = "cb_help_reference_v1";
  const ATTRIBUTION_TTL = 30 * 24 * 60 * 60 * 1000;
  const state = { locale: "en", category: null, detail: null };

  const copy = {
    en: {
      launcher: "Help & WhatsApp", launcherAria: "Open ConeBarn customer help",
      eyebrow: "CONEBARN", firstTitle: "How can we help?", intro: "Choose a topic so we can help you faster.",
      language: "Language", back: "Back", close: "Close help", optional: "Optional", skip: "Skip details and chat directly",
      continue: "Continue on WhatsApp", direct: "Chat directly", products: "View related products",
      country: "Delivery country / region", countryPlaceholder: "For example: Brazil",
      interest: "Product(s) of interest", interestPlaceholder: "Product name or link",
      quantity: "Estimated quantity", quantityPlaceholder: "For example: 5 boxes, 1,000 pieces, or 3 units",
      order: "Order number", orderPlaceholder: "If available",
      question: "Brief description", questionPlaceholder: "Tell us what you need help with",
      detailPrompt: "Which situation fits best?", noNeed: "You can continue without completing the optional fields.",
      clickNote: "WhatsApp will open with a draft message. Please review and send it yourself.",
      selfReport: "Your selection describes your experience and is not a verified payment-system result.",
      opening: "Opening WhatsApp…", source: "Entry source", campaign: "Campaign", content: "Content",
      product: "Product", link: "Product link", countryField: "Delivery country / region", quantityField: "Estimated quantity",
      interestField: "Product(s) of interest", orderField: "Order number", questionField: "Question", reference: "Reference",
      categories: {
        payment: ["Checkout or payment help", "Checkout or payment"],
        wholesale: ["Bulk orders / wholesale", "Bulk orders / wholesale"],
        accessories: ["Rolling machines & accessories", "Rolling machines & accessories"],
        cones: ["Pre-rolled cones, papers & tips", "Pre-rolled cones, papers & tips"],
        shipping: ["Shipping costs & delivery", "Shipping costs & delivery"],
        order: ["Help with an existing order", "Existing order help"],
        other: ["Something else", "Other question"]
      },
      details: {
        payment: [
          ["not_tried", "I have not tried to pay yet and want to know how to order."],
          ["method_missing", "I do not have a Visa credit or debit card I can use."],
          ["card_declined", "My Visa card was declined after I tried to pay."],
          ["checkout_error", "The checkout page will not open, is stuck, or shows an error."],
          ["amount_question", "I have a question about the USD charge, exchange rate, shipping, or final amount."],
          ["charged_no_confirmation", "I was charged but did not receive an order confirmation."]
        ],
        wholesale: [["personal_bulk", "Bulk purchase for personal use"], ["resale", "Wholesale for resale"], ["agency", "Agency / distributor cooperation"]],
        accessories: [["manual_machine", "Manual rolling machine"], ["automatic_machine", "Automatic rolling machine"], ["other_accessory", "Other smoking tool or accessory"], ["recommendation", "Not sure — I need a recommendation"]],
        cones: [["pre_rolled_cones", "Pre-rolled cones"], ["rolling_papers", "Rolling papers"], ["tips", "Tips"], ["recommendation", "Not sure — I need a recommendation"]]
      },
      greeting: "Hi ConeBarn,", need: "I need help with", specific: "Specific question"
    },
    pt: {
      launcher: "Ajuda no WhatsApp", launcherAria: "Abrir atendimento da ConeBarn",
      eyebrow: "CONEBARN", firstTitle: "Como podemos ajudar?", intro: "Escolha um assunto para atendermos você mais rapidamente.",
      language: "Idioma", back: "Voltar", close: "Fechar atendimento", optional: "Opcional", skip: "Pular os detalhes e falar diretamente",
      continue: "Continuar no WhatsApp", direct: "Falar diretamente", products: "Ver produtos relacionados",
      country: "País / região de entrega", countryPlaceholder: "Por exemplo: Brasil",
      interest: "Produto(s) de interesse", interestPlaceholder: "Nome ou link do produto",
      quantity: "Quantidade estimada", quantityPlaceholder: "Por exemplo: 5 caixas, 1.000 unidades ou 3 peças",
      order: "Número do pedido", orderPlaceholder: "Se estiver disponível",
      question: "Descrição breve", questionPlaceholder: "Conte brevemente como podemos ajudar",
      detailPrompt: "Qual situação descreve melhor o seu caso?", noNeed: "Você pode continuar sem preencher os campos opcionais.",
      clickNote: "O WhatsApp abrirá com uma mensagem de rascunho. Revise e envie você mesmo.",
      selfReport: "A opção escolhida descreve sua experiência e não é uma confirmação do sistema de pagamento.",
      opening: "Abrindo o WhatsApp…", source: "Origem da visita", campaign: "Campanha", content: "Conteúdo",
      product: "Produto", link: "Link do produto", countryField: "País / região de entrega", quantityField: "Quantidade estimada",
      interestField: "Produto(s) de interesse", orderField: "Número do pedido", questionField: "Pergunta", reference: "Referência",
      categories: {
        payment: ["Ajuda com checkout ou pagamento", "Checkout ou pagamento"],
        wholesale: ["Pedidos em grande quantidade / atacado", "Pedidos em grande quantidade / atacado"],
        accessories: ["Máquinas de enrolar e acessórios", "Máquinas de enrolar e acessórios"],
        cones: ["Cones pré-enrolados, papéis e filtros", "Cones pré-enrolados, papéis e filtros"],
        shipping: ["Custos de frete e entrega", "Custos de frete e entrega"],
        order: ["Ajuda com um pedido existente", "Ajuda com pedido existente"],
        other: ["Outro assunto", "Outra pergunta"]
      },
      details: {
        payment: [
          ["not_tried", "Ainda não tentei pagar e quero saber como fazer o pedido."],
          ["method_missing", "Não tenho um cartão Visa de crédito ou débito que eu possa usar."],
          ["card_declined", "Meu cartão Visa foi recusado depois que tentei pagar."],
          ["checkout_error", "A página de checkout não abre, travou ou mostra um erro."],
          ["amount_question", "Tenho dúvidas sobre a cobrança em USD, o câmbio, o frete ou o valor final."],
          ["charged_no_confirmation", "O valor foi cobrado, mas não recebi a confirmação do pedido."]
        ],
        wholesale: [["personal_bulk", "Compra em grande quantidade para uso pessoal"], ["resale", "Atacado para revenda"], ["agency", "Parceria como agente / distribuidor"]],
        accessories: [["manual_machine", "Máquina manual de enrolar"], ["automatic_machine", "Máquina automática de enrolar"], ["other_accessory", "Outro utensílio ou acessório"], ["recommendation", "Não tenho certeza — preciso de recomendação"]],
        cones: [["pre_rolled_cones", "Cones pré-enrolados"], ["rolling_papers", "Papéis para enrolar"], ["tips", "Filtros / tips"], ["recommendation", "Não tenho certeza — preciso de recomendação"]]
      },
      greeting: "Olá ConeBarn,", need: "Preciso de ajuda com", specific: "Situação"
    },
    es: {
      launcher: "Ayuda por WhatsApp", launcherAria: "Abrir ayuda de ConeBarn",
      eyebrow: "CONEBARN", firstTitle: "¿Cómo podemos ayudarte?", intro: "Elige un tema para que podamos ayudarte más rápido.",
      language: "Idioma", back: "Volver", close: "Cerrar ayuda", optional: "Opcional", skip: "Omitir detalles y hablar directamente",
      continue: "Continuar en WhatsApp", direct: "Hablar directamente", products: "Ver productos relacionados",
      country: "País / región de entrega", countryPlaceholder: "Por ejemplo: México",
      interest: "Producto(s) de interés", interestPlaceholder: "Nombre o enlace del producto",
      quantity: "Cantidad estimada", quantityPlaceholder: "Por ejemplo: 5 cajas, 1,000 unidades o 3 piezas",
      order: "Número de pedido", orderPlaceholder: "Si está disponible",
      question: "Descripción breve", questionPlaceholder: "Cuéntanos brevemente en qué podemos ayudarte",
      detailPrompt: "¿Qué situación describe mejor tu caso?", noNeed: "Puedes continuar sin completar los campos opcionales.",
      clickNote: "WhatsApp se abrirá con un mensaje en borrador. Revísalo y envíalo tú mismo.",
      selfReport: "La opción elegida describe tu experiencia y no es una verificación del sistema de pago.",
      opening: "Abriendo WhatsApp…", source: "Origen de la visita", campaign: "Campaña", content: "Contenido",
      product: "Producto", link: "Enlace del producto", countryField: "País / región de entrega", quantityField: "Cantidad estimada",
      interestField: "Producto(s) de interés", orderField: "Número de pedido", questionField: "Pregunta", reference: "Referencia",
      categories: {
        payment: ["Ayuda con checkout o pago", "Checkout o pago"],
        wholesale: ["Pedidos al por mayor / mayoreo", "Pedidos al por mayor / mayoreo"],
        accessories: ["Máquinas de liar y accesorios", "Máquinas de liar y accesorios"],
        cones: ["Conos preenrollados, papeles y filtros", "Conos preenrollados, papeles y filtros"],
        shipping: ["Costos de envío y entrega", "Costos de envío y entrega"],
        order: ["Ayuda con un pedido existente", "Ayuda con un pedido existente"],
        other: ["Otro asunto", "Otra pregunta"]
      },
      details: {
        payment: [
          ["not_tried", "Todavía no he intentado pagar y quiero saber cómo hacer el pedido."],
          ["method_missing", "No tengo una tarjeta Visa de crédito o débito que pueda utilizar."],
          ["card_declined", "Mi tarjeta Visa fue rechazada después de intentar pagar."],
          ["checkout_error", "La página de checkout no abre, se queda bloqueada o muestra un error."],
          ["amount_question", "Tengo dudas sobre el cobro en USD, el cambio, el envío o el importe final."],
          ["charged_no_confirmation", "Me cobraron, pero no recibí la confirmación del pedido."]
        ],
        wholesale: [["personal_bulk", "Compra en cantidad para uso personal"], ["resale", "Mayoreo para reventa"], ["agency", "Colaboración como agente / distribuidor"]],
        accessories: [["manual_machine", "Máquina manual de liar"], ["automatic_machine", "Máquina automática de liar"], ["other_accessory", "Otro utensilio o accesorio"], ["recommendation", "No estoy seguro — necesito una recomendación"]],
        cones: [["pre_rolled_cones", "Conos preenrollados"], ["rolling_papers", "Papeles para liar"], ["tips", "Filtros / tips"], ["recommendation", "No estoy seguro — necesito una recomendación"]]
      },
      greeting: "Hola ConeBarn,", need: "Necesito ayuda con", specific: "Situación"
    }
  };

  const pageLocale = () => {
    const path = location.pathname.toLowerCase();
    if (path === "/pt" || path.startsWith("/pt/")) return "pt";
    if (path === "/es" || path.startsWith("/es/") || path === "/es-mx" || path.startsWith("/es-mx/")) return "es";
    const value = (document.documentElement.lang || navigator.language || "en").toLowerCase();
    return value.startsWith("pt") ? "pt" : value.startsWith("es") ? "es" : "en";
  };

  const safeGet = (storage, key) => { try { return storage.getItem(key); } catch (_) { return null; } };
  const safeSet = (storage, key, value) => { try { storage.setItem(key, value); } catch (_) {} };
  const clean = (value, limit = 160) => String(value || "").replace(/[\r\n|]/g, " ").trim().slice(0, limit);
  const html = value => String(value).replace(/[&<>'"]/g, character => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" })[character]);

  function currentTouch() {
    const params = new URLSearchParams(location.search);
    let referrerHost = "";
    try { referrerHost = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, "") : ""; } catch (_) {}
    let source = clean(params.get("utm_source"), 80);
    if (!source && params.get("ttclid")) source = "tiktok";
    if (!source && params.get("fbclid")) source = "facebook-instagram";
    if (!source && params.get("gclid")) source = "google";
    if (!source && referrerHost && referrerHost !== location.hostname.replace(/^www\./, "")) source = referrerHost;
    return {
      source: source || "direct_or_untracked",
      medium: clean(params.get("utm_medium"), 80), campaign: clean(params.get("utm_campaign"), 100),
      content: clean(params.get("utm_content"), 100), landing: clean(location.pathname, 220),
      capturedAt: new Date().toISOString()
    };
  }

  function getAttribution() {
    const touch = currentTouch();
    let stored = null;
    try { stored = JSON.parse(safeGet(localStorage, ATTRIBUTION_KEY) || "null"); } catch (_) {}
    const expired = !stored || !stored.capturedAt || Date.now() - Date.parse(stored.capturedAt) > ATTRIBUTION_TTL;
    const tagged = touch.source !== "direct_or_untracked" || touch.campaign || touch.content;
    if (expired || tagged) {
      stored = touch;
      safeSet(localStorage, ATTRIBUTION_KEY, JSON.stringify(stored));
    }
    return stored || touch;
  }

  function reference() {
    let value = safeGet(sessionStorage, SESSION_KEY);
    if (value) return value;
    const random = crypto?.getRandomValues
      ? Array.from(crypto.getRandomValues(new Uint8Array(4)), n => n.toString(16).padStart(2, "0")).join("")
      : Math.random().toString(36).slice(2, 10);
    value = `CB-${random.toUpperCase()}`;
    safeSet(sessionStorage, SESSION_KEY, value);
    return value;
  }

  function pageContext() {
    const productPath = location.pathname.match(/\/products\/([^/?#]+)/);
    const productName = document.querySelector('meta[property="og:title"]')?.content || document.querySelector("h1")?.textContent || "";
    return {
      page_type: productPath ? "product" : location.pathname.includes("/collections/") ? "collection" : location.pathname === "/cart" ? "cart" : location.pathname === "/" ? "home" : "other",
      product_handle: productPath ? clean(productPath[1], 120) : null,
      product_name: productPath ? clean(productName, 180) : null,
      product_link: productPath ? `${location.origin}${location.pathname}` : null
    };
  }

  function track(name, detail = {}) {
    const context = pageContext();
    const payload = { event: name, page_path: location.pathname, page_type: context.page_type, product_handle: context.product_handle, page_language: state.locale, ...detail };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent(`conebarn:${name}`, { detail: payload }));
    try {
      const result = window.Shopify?.analytics?.publish(`conebarn:${name}`, payload);
      if (result && typeof result.catch === "function") result.catch(() => {});
    } catch (_) {}
  }

  function detailsFor(category) { return copy[state.locale].details[category] || []; }
  function selectedDetailText() {
    const found = detailsFor(state.category).find(item => item[0] === state.detail);
    return found ? found[1] : "";
  }

  function field(label, name, placeholder, multiline = false) {
    const tag = multiline
      ? `<textarea name="${name}" rows="3" maxlength="300" placeholder="${html(placeholder)}"></textarea>`
      : `<input name="${name}" type="text" maxlength="180" placeholder="${html(placeholder)}">`;
    return `<label class="cb-help-field"><span>${html(label)} <small>(${html(copy[state.locale].optional)})</small></span>${tag}</label>`;
  }

  function categoryIcon(key) {
    return { payment: "▣", wholesale: "◇", accessories: "☷", cones: "▱", shipping: "▤", order: "☑", other: "?" }[key];
  }

  function relatedUrl(category) {
    const root = window.Shopify?.routes?.root || "/";
    if (category === "accessories") return `${root}collections/all#cb-tools`;
    if (category === "cones") return `${root}collections/all?view=cones-empty-tubes#cb-cones`;
    if (category === "wholesale") return `${root}pages/wholesale`;
    return null;
  }

  function firstLayer() {
    const t = copy[state.locale];
    const keys = ["payment", "wholesale", "accessories", "cones", "shipping", "order", "other"];
    return `<p class="cb-help-intro">${html(t.intro)}</p><div class="cb-help-topics">${keys.map(key =>
      `<button class="cb-help-topic" type="button" data-help-category="${key}"><span class="cb-help-topic__icon" aria-hidden="true">${categoryIcon(key)}</span><span>${html(t.categories[key][0])}</span><span aria-hidden="true">›</span></button>`
    ).join("")}</div><div class="cb-help-direct"><button type="button" data-help-direct>${html(t.direct)}</button></div>`;
  }

  function secondLayer() {
    const t = copy[state.locale];
    const options = detailsFor(state.category);
    const choices = options.length ? `<fieldset class="cb-help-choice"><legend>${html(t.detailPrompt)} <small>(${html(t.optional)})</small></legend>${options.map(item =>
      `<label><input type="radio" name="help_detail" value="${item[0]}"><span>${html(item[1])}</span></label>`
    ).join("")}</fieldset>` : "";
    let fields = "";
    if (["payment", "shipping", "wholesale"].includes(state.category)) fields += field(t.country, "country", t.countryPlaceholder);
    if (state.category === "wholesale") {
      fields = field(t.interest, "interest", t.interestPlaceholder) + field(t.quantity, "quantity", t.quantityPlaceholder) + fields;
    }
    if (state.category === "order") fields += field(t.order, "order", t.orderPlaceholder);
    if (state.category === "other") fields += field(t.question, "question", t.questionPlaceholder, true);
    const related = relatedUrl(state.category);
    return `<button class="cb-help-back" type="button" data-help-back>← ${html(t.back)}</button><h3>${html(t.categories[state.category][0])}</h3>` +
      `${choices}<div class="cb-help-fields">${fields}</div><p class="cb-help-optional-note">${html(t.noNeed)}</p>` +
      `${state.category === "payment" ? `<p class="cb-help-self-report">${html(t.selfReport)}</p>` : ""}` +
      `${related ? `<a class="cb-help-related" href="${related}" data-help-related>${html(t.products)} →</a>` : ""}` +
      `<button class="cb-help-continue" type="button" data-help-continue>${html(t.continue)}</button>` +
      `<button class="cb-help-skip" type="button" data-help-continue>${html(t.skip)}</button><p class="cb-help-click-note">${html(t.clickNote)}</p><p class="cb-help-status" aria-live="polite"></p>`;
  }

  function render() {
    const panel = document.querySelector("[data-cb-support-panel]");
    if (!panel) return;
    const t = copy[state.locale];
    panel.querySelector(".cb-support-panel__eyebrow").textContent = t.eyebrow;
    panel.querySelector("#ConeBarnSupportTitle").textContent = state.category ? t.categories[state.category][1] : t.firstTitle;
    panel.querySelector("[data-cb-support-close]").setAttribute("aria-label", t.close);
    const body = panel.querySelector(".cb-support-panel__body");
    body.innerHTML = `<label class="cb-help-language"><span>${html(t.language)}</span><select data-help-language><option value="en"${state.locale === "en" ? " selected" : ""}>English</option><option value="pt"${state.locale === "pt" ? " selected" : ""}>Português</option><option value="es"${state.locale === "es" ? " selected" : ""}>Español</option></select></label>` + (state.category ? secondLayer() : firstLayer());
    body.querySelector("[data-help-language]").addEventListener("change", event => { state.locale = event.target.value; render(); syncLauncher(); });
    body.querySelectorAll("[data-help-category]").forEach(button => button.addEventListener("click", () => {
      state.category = button.dataset.helpCategory; state.detail = null;
      track("support_category_selected", { help_category: state.category }); render();
    }));
    body.querySelector("[data-help-back]")?.addEventListener("click", () => { state.category = null; state.detail = null; track("support_back_clicked"); render(); });
    body.querySelectorAll('input[name="help_detail"]').forEach(input => input.addEventListener("change", () => {
      state.detail = input.value; track("support_detail_selected", { help_category: state.category, help_detail: state.detail });
    }));
    body.querySelector("[data-help-related]")?.addEventListener("click", () => track("support_related_products_clicked", { help_category: state.category }));
    body.querySelectorAll("[data-help-continue]").forEach(button => button.addEventListener("click", () => continueToWhatsApp(body)));
    body.querySelector("[data-help-direct]")?.addEventListener("click", () => directChat(body));
  }

  function formValue(body, name) { return clean(body.querySelector(`[name="${name}"]`)?.value, 300); }

  function message(body, direct = false) {
    const t = copy[state.locale];
    const attribution = getAttribution();
    const context = pageContext();
    const lines = [t.greeting];
    if (!direct && state.category) {
      lines.push(`${t.need}: ${t.categories[state.category][1]}.`);
      const detail = selectedDetailText();
      if (detail) lines.push(`${t.specific}: ${detail}`);
      const interest = formValue(body, "interest"); if (interest) lines.push(`${t.interestField}: ${interest}`);
      const quantity = formValue(body, "quantity"); if (quantity) lines.push(`${t.quantityField}: ${quantity}`);
      const country = formValue(body, "country"); if (country) lines.push(`${t.countryField}: ${country}`);
      const order = formValue(body, "order"); if (order) lines.push(`${t.orderField}: ${order}`);
      const question = formValue(body, "question"); if (question) lines.push(`${t.questionField}: ${question}`);
    }
    if (context.product_name) lines.push(`${t.product}: ${context.product_name}`);
    if (context.product_link) lines.push(`${t.link}: ${context.product_link}`);
    lines.push(`${t.source}: ${attribution.source}`);
    if (attribution.campaign) lines.push(`${t.campaign}: ${attribution.campaign}`);
    if (attribution.content) lines.push(`${t.content}: ${attribution.content}`);
    lines.push(`${t.reference}: ${reference()}`);
    return lines.join("\n");
  }

  function openWhatsApp(body, direct = false) {
    const t = copy[state.locale];
    const status = body.querySelector(".cb-help-status");
    if (status) status.textContent = t.opening;
    const attribution = getAttribution();
    track("support_whatsapp_clicked", {
      help_category: direct ? "direct" : state.category,
      help_detail: direct ? null : state.detail,
      entry_source: attribution.source,
      utm_campaign: attribution.campaign || null,
      utm_content: attribution.content || null,
      help_reference: reference()
    });
    if (!SUPPORT_NUMBER) return;
    window.open(`https://wa.me/${SUPPORT_NUMBER}?text=${encodeURIComponent(message(body, direct))}`, "_blank", "noopener,noreferrer");
  }

  function continueToWhatsApp(body) { openWhatsApp(body, false); }
  function directChat(body) { openWhatsApp(body, true); }

  function syncLauncher() {
    const launcher = document.querySelector("[data-cb-support-trigger]");
    if (!launcher) return;
    const t = copy[state.locale];
    launcher.classList.add("cb-support-launcher--gold");
    launcher.setAttribute("aria-label", t.launcherAria);
    const label = launcher.querySelector("span");
    if (label) label.textContent = t.launcher;
  }

  function mount() {
    const launcher = document.querySelector("[data-cb-support-trigger]");
    const panel = document.querySelector("[data-cb-support-panel]");
    if (!launcher || !panel) return;
    state.locale = pageLocale();
    getAttribution();
    syncLauncher();
    render();
    launcher.addEventListener("click", () => {
      state.category = null; state.detail = null; render();
      track("support_panel_opened", { entry_source: getAttribution().source });
    });
  }

  function prioritizeToolsOnAllProducts() {
    if (!/^\/collections\/all\/?$/.test(window.location.pathname)) return;
    const grid = document.querySelector("#product-grid");
    const cones = grid?.querySelector("#cb-cones");
    const tools = grid?.querySelector("#cb-tools");
    if (!grid || !cones || !tools || grid.dataset.cbOrderFinalized === "true") return;
    const children = Array.from(grid.children);
    if (children.indexOf(tools) > children.indexOf(cones)) {
      const toolGroup = [];
      let node = tools;
      while (node) {
        toolGroup.push(node);
        node = node.nextElementSibling;
      }
      toolGroup.forEach(item => grid.insertBefore(item, cones));
    }

    const productCard = handle => grid.querySelector(`a[href*="/products/${handle}"]`)?.closest("li.grid__item");
    const brass = productCard("brass-manual-cigarette-roller-hand-rolling-tool");
    const firstToolCard = tools.nextElementSibling;
    if (brass && firstToolCard && brass !== firstToolCard.nextElementSibling) {
      grid.insertBefore(brass, firstToolCard.nextElementSibling);
    }

    // Respect the Shopify collection order; these cards only need the existing
    // animation cleanup, not a second hard-coded position at the tools' tail.
    const revealToolHandles = [
      "middle-finger-zinc-alloy-grinder-pipe",
      "thor-hammer-zinc-alloy-grinder-pipe"
    ];
    const revealCards = revealToolHandles.map(productCard).filter(Boolean);

    // Dawn's scroll animation observer is initialized before the custom product
    // ordering runs. Moving an off-screen card can leave it permanently at
    // opacity .01, and repeated DOM moves make the card appear to flash. The
    // custom order is final, so reveal only the cards that this function moves.
    [brass, ...revealCards].filter(Boolean).forEach(card => {
      card.classList.remove("scroll-trigger", "animate--slide-in", "scroll-trigger--offscreen");
      card.style.removeProperty("--animation-order");
      card.style.removeProperty("opacity");
      card.style.removeProperty("transform");
    });
    grid.dataset.cbOrderFinalized = "true";
  }

  function init() {
    prioritizeToolsOnAllProducts();
    mount();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
